import { defineNuxtPlugin } from '#imports'
import { vMotion, createPresetDirective } from 'motion-v'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('motion', vMotion)
})
